module.exports = __webpack_public_path__ + "img/2.cee5d15c.png";